import styled from "styled-components";

export const SAddMemberModal = styled.div`
  width: 530px;
`;
